/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertToRupiah } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@tour/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Transaction';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'transaction';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [judul, set_judul] = useState('')
    const [provinsi , set_provinsi] = useState('')
    const [minimal_orang , set_minimal_orang] = useState('')
    const [maksimal_orang , set_maksimal_orang] = useState('')
    const [lokasi , set_lokasi] = useState('')
    const [jadwal , set_jadwal] = useState('')
    const [durasi , set_durasi] = useState('')
    const [meepo , set_meepo] = useState('')
    const [refund , set_refund] = useState('')
    const [fasilitas , set_fasilitas] = useState('')
    const [itinerary , set_itinerary] = useState('')
    const [price , set_price] = useState(0)
    const [discount , set_discount] = useState(0)
    const [kuota , set_kuota] = useState('')
    const [uniquename_brand , set_uniquename_brand] = useState('')

    const [card_number, set_card_number] = useState('5264 2210 3887 4659')
    const [card_exp_month, set_card_exp_month] = useState('12')
    const [card_exp_year, set_card_exp_year] = useState('2025')
    const [card_cvv, set_card_cvv] = useState('123')
    const [redirect_url, set_redirect_url] = useState('')
    const [order_id, set_order_id] = useState('')

    const [search_product, set_search_product] = useState('')
    const [data_product, set_data_product] = useState(null);
    const [data_product_select, set_data_product_select] = useState(null);
    const [data_buyer, set_data_buyer] = useState(null);
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`tour/transaction/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`tour/transaction/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _search_product = () => {

        if(loading === true){
            return
        }
        
        if(search_product.length > 3){
    
            API_GET_REQUEST(`tour/payment/get__________?action=search_product`
                + '&bamboo_user=' + bamboo_user
                + '&filter=' + filter
                + '&search=' + search_product
            , 
            ).then((response) => {
                console_dev(`response search product`, response.data)
                if(response.data.result == 'success'){
                    set_data_product(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        data.append("judul", judul);
        data.append("provinsi", provinsi);
        data.append("minimal_orang", minimal_orang);
        data.append("maksimal_orang", maksimal_orang);
        data.append("lokasi", lokasi);
        data.append("jadwal", jadwal);
        data.append("durasi", durasi);
        data.append("meepo", meepo);
        data.append("refund", refund);
        data.append("fasilitas", JSON.stringify(fasilitas));
        data.append("itinerary", JSON.stringify(itinerary));
        data.append("price", price);
        data.append("discount", discount);
        data.append("kuota", kuota);
        data.append("type", type);
        data.append("uniquename_brand", STORAGE_USER[0].uniquename);
        data.append("tick", STORAGE_USER[0].tick);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "tour/transaction/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                set_judul('')
                set_provinsi('')
                set_minimal_orang('')
                set_maksimal_orang('')
                set_lokasi('')
                set_jadwal('')
                set_durasi('')
                set_meepo('')
                set_refund('')
                set_fasilitas('')
                set_itinerary('')
                set_price(0)
                set_discount(0)
                set_kuota('')
                set_type('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('tour/payment/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            card_number : card_number, 
            card_exp_month : card_exp_month,
            card_exp_year : card_exp_year,
            card_cvv : card_cvv,

            bamboo_product: data_product_select.bamboo,
            bamboo_user_product: data_product_select.bamboo_user,
            judul: data_product_select.judul,
            price: data_product_select.price,
            discount: data_product_select.discount,
            uniquename_brand : STORAGE_USER[0].uniquename,
            tick : STORAGE_USER[0].tick,
            slug: data_product_select.slug,
            data_buyer: JSON.stringify({
                data_product : data_product_select,
                data_user : STORAGE_USER[0]
            })

		}).then((response) => {
            console_dev(`response payment uploads post`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
                set_card_number('') 
                set_card_exp_month('')
                set_card_exp_year('')
                set_card_cvv('')
                set_data_product_select(null)
			}else if(response.data.result === 'auth'){
                window.location.href = response.data.data.redirect_url; 
             }else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'connect',
        //     room: 'room_forum_user_authentication',
        //     status: 'online',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}

    const _socket_offline = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'disconnect',
        //     room: 'room_forum_user_authentication',
        //     status: 'offline',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket_online(STORAGE_USER[0])
                _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])

    useEffect(() => {

        if(search_product.length > 0){
            _search_product()
        }else{
            set_data_product(null)
            set_data_product_select(null)
        }

    }, [search_product])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>

            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Bayarkan
                    </div>
                </div>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Payment</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">
                                    <div className="_container">
                                        <div>
                                            <div className="_row_auto _push_b_g" style={{marginLeft: -10, marginRight: -10}}>
                                                <div className="_column_auto">
                                                    <div className="_heading_bold _push_b_l">
                                                        Cloud : <span className="_grey">Server Pembayaran</span>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Kategori
                                                        </p>
                                                        <div className="_e_input">
                                                            <div className="_row _center_align">
                                                                <div className="_column">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        onChange={e => set_filter(e.target.value)}
                                                                        value={filter}
                                                                    />
                                                                </div>
                                                                <div onClick={() => {
                                                                    if(sub_element === 'sub_dropdown'){
                                                                        set_sub_element(null)
                                                                    }else{
                                                                        set_sub_element('sub_dropdown')
                                                                    }
                                                                }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'sub_dropdown' ? '#eee' : null}}>
                                                                    <div className="_row _center_align">
                                                                        <div className="_push_t_t">
                                                                            {
                                                                                sub_element === 'sub_dropdown' ?
                                                                                    <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                :
                                                                                    <ion-icon name="chevron-down-outline"></ion-icon>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="_relative">
                                                                {
                                                                    sub_element === 'sub_dropdown' ?
                                                                        // _left or _right
                                                                        <>
                                                                            <div className="_fmc_overlay_dropdown _right">
                                                                                <div onClick={() => {set_filter('Open Trip')}} className="_item" style={{backgroundColor: filter === 'Open Trip' ? '#eee' : null}}>Open Trip</div>
                                                                                <div onClick={() => {set_filter('Tour Guide')}} className="_item" style={{backgroundColor: filter === 'Tour Guide' ? '#eee' : null}}>Tour Guide</div>
                                                                                <div onClick={() => {set_filter('Rental')}} className="_item" style={{backgroundColor: filter === 'Rental' ? '#eee' : null}}>Rental</div>
                                                                                <div onClick={() => {set_filter('Souvenir')}} className="_item" style={{backgroundColor: filter === 'Souvenir' ? '#eee' : null}}>Souvenir</div>
                                                                                <div onClick={() => {set_filter('Culinary')}} className="_item" style={{backgroundColor: filter === 'Culinary' ? '#eee' : null}}>Culinary</div>
                                                                                <div onClick={() => {set_filter('Ticket')}} className="_item" style={{backgroundColor: filter === 'Ticket' ? '#eee' : null}}>Ticket</div>
                                                                            </div>
                                                                        </>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent', borderRadius: 5}}>
                                                        <div className="_row _center_align">
                                                            <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                                                            <div className="_column">
                                                                <input 
                                                                    placeholder="Cari" 
                                                                    onChange={e => set_search_product(e.target.value)}
                                                                    value={search_product}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    {
                                                        data_product && data_product.list.map((item, index) => {
                                                            return(
                                                                <div onClick={() => {
                                                                    set_data_product_select(item)
                                                                }} key={index} className="_row _cursor_pointer _push_b_m">
                                                                    <div style={{width: 100, marginRight: 10, height: 100, backgroundColor: '#f5f5f5', borderRadius: 5, overflow: 'hidden', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER + '/' + item.path + '/' + item.file})`}}>

                                                                    </div>
                                                                    <div className="_column">
                                                                        <p>Title : {decode(item.judul)}</p>
                                                                        <p>Price : {decode(convertToRupiah(item.price))}</p>
                                                                        <p>Discount : {decode(item.discount)}%</p>
                                                                        <p>@{decode(item.uniquename_brand)}</p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                    {
                                                        data_product_select &&
                                                        <>
                                                            <div className="_relative _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Title
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        value={data_product_select.judul}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Price
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        value={data_product_select.price}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Discount
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        value={data_product_select.discount}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="_relative _push_b_d">
                                                                <p style={{color: '#888', fontSize: 13}}>
                                                                    <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                    Brand
                                                                </p>
                                                                <div className="_e_input">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        value={data_product_select.uniquename_brand}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div onClick={() => {
                                                                _uploads_post(`insert_payment_credit`)
                                                                // _uploads(`insert_${request_params}`)
                                                            }} className="_btn _cursor_pointer _push_r_m _push_t_d">
                                                                Pay Now
                                                            </div>
                                                        </>
                                                    }
                                                    {/* <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Sub Dropdown
                                                        </p>
                                                        <div className="_e_input">
                                                            <div className="_row _center_align">
                                                                <div className="_column">
                                                                    <input 
                                                                        placeholder=""
                                                                        type={'text'} 
                                                                        // onChange={e => set_input(e.target.value)}
                                                                        // value={input}
                                                                    />
                                                                </div>
                                                                <div onClick={() => {
                                                                    if(sub_element === 'sub_dropdown'){
                                                                        set_sub_element(null)
                                                                    }else{
                                                                        set_sub_element('sub_dropdown')
                                                                    }
                                                                }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === 'sub_dropdown' ? '#eee' : null}}>
                                                                    <div className="_row _center_align">
                                                                        <div className="_push_t_t">
                                                                            {
                                                                                sub_element === 'sub_dropdown' ?
                                                                                    <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                :
                                                                                    <ion-icon name="chevron-down-outline"></ion-icon>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="_relative">
                                                                {
                                                                    sub_element === 'sub_dropdown' ?
                                                                        // _left or _right
                                                                        <>
                                                                            <div className="_fmc_overlay_dropdown _right">
                                                                                <div onClick={() => {set_input('Input')}} className="_item" style={{backgroundColor: input === 'Input' ? '#eee' : null}}>Input</div>
                                                                            </div>
                                                                        </>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Input
                                                        </p>
                                                        <div className="_e_input">
                                                            <div className="_row _center_align">
                                                                <div className="_push_r_t">
                                                                    Rp.
                                                                </div>
                                                                <div className="_column">
                                                                    <CurrencyFormat 
                                                                        value={input} 
                                                                        thousandSeparator={true} 
                                                                        prefix={''}
                                                                        onValueChange={(e) => {
                                                                            if(e.value.length < 10){
                                                                                set_input(e.value)
                                                                            }else{
                                                                                set_input('')
                                                                                error('Max Length')
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                    {/* <p className="_push_b_m _cl_smooth_0">Description</p> */}
                                                    {/* <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                        <div className="_e_input">
                                                            <input
                                                                className="custom-file-input" 
                                                                type="file"
                                                                name="file"
                                                                placeholder=""
                                                                onChange={_files}
                                                            />
                                                        </div>
                                                    </div> */}
                                                </div>
                                                
                                                <div className="_column_auto">
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    : null
                }
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                // _uploads_post(`delete_${request_params}`)
                                                _uploads(`delete_${request_params}`)
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Detail Transaction</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            {
                                                console.log('data buyer', data_buyer)
                                            }
                                            {
                                                data_buyer &&
                                                <>
                                                    <div className="_row _cursor_pointer _push_b_m">
                                                        <div style={{width: 100, marginRight: 16, height: 100, backgroundColor: '#f5f5f5', borderRadius: 5, overflow: 'hidden', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER + '/' + data_buyer.data.data_product.path + '/' + data_buyer.data.data_product.file})`}}>

                                                        </div>
                                                        <div className="_column">
                                                            <div className="_push_b_d">
                                                                Judul : {decode(data_buyer.data.data_product.judul)}<br/>
                                                                Price : {decode(convertToRupiah(data_buyer.data.data_product.price))}<br/>
                                                                Discount : {decode(data_buyer.data.data_product.discount)}%<br/>
                                                                Durasi : {decode(data_buyer.data.data_product.durasi)}<br/>
                                                                Jadwal : {decode(data_buyer.data.data_product.jadwal)}<br/>
                                                                Kuota : {decode(data_buyer.data.data_product.kuota)}<br/>
                                                                Lokasi : {decode(data_buyer.data.data_product.lokasi)}<br/>
                                                                Maksimal_orang : {decode(data_buyer.data.data_product.maksimal_orang)}<br/>
                                                                Meeting Point : {decode(data_buyer.data.data_product.meepo)}<br/>
                                                                Minimal Orang : {decode(data_buyer.data.data_product.minimal_orang)}<br/>
                                                                Provinsi : {decode(data_buyer.data.data_product.provinsi)}<br/>
                                                                Refund : {decode(data_buyer.data.data_product.refund)}<br/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="_row _cursor_pointer _push_b_m">
                                                        <div style={{width: 100, marginRight: 16, height: 100, backgroundColor: '#f5f5f5', borderRadius: 5, overflow: 'hidden', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundImage: `url(${API_SERVER + '/' + data_buyer.data.data_user.path + '/' + data_buyer.data.data_user.photo})`}}>

                                                        </div>
                                                        <div className="_column">
                                                            <div className="_push_b_d">
                                                                Name : {decode(data_buyer.data.data_user.name)}<br/>
                                                                Location : {decode(data_buyer.data.data_user.location)}<br/>
                                                                Email :  {decode(data_buyer.data.data_user.email)}<br/>
                                                                No.HP : {decode(data_buyer.data.data_user.no_hp)}<br/>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}


            {/*  Search -------------------------------------------------------------------- */}
            <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            {/*  End Search ---------------------------------------------------------------- */}

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_data_table_transition" style={{height: table_height}}>
                <div className="_overflow_x" ref={ref_table_height}>
                    <table className="_table">
                        <thead>
                            <tr>
                                <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                                <th>Order ID</th>
                                <th>Judul</th>
                                <th>Price</th>
                                <th>Discount</th>
                                <th>Status</th>
                                <th>
                                    <div className="_right_text">
                                        <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data && data.list.length > 0 ? 
                                    data.list.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {/* <td>
                                                <a href={API_SERVER + '/' + item.path + '/' + item.file} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                            </td> */}
                                            <td>{decode(item.order_id)}</td>
                                            <td>{decode(item.judul)}</td>
                                            <td>{convertToRupiah(decode(item.price))}</td>
                                            <td>{decode(item.discount)}%</td>
                                            <td>{
                                                    item.status === 'capture' ? 
                                                        <span className="_badge_green">Approved</span> 
                                                    : item.status === 'request' ? 
                                                        <span className="_badge_green" style={{backgroundColor: 'orange'}}>Request</span> 
                                                    : 
                                                        <span className="_badge_green" style={{backgroundColor: 'red'}}>Expired</span>
                                                }
                                            </td>
                                            <td>
                                                <div className="_right_text _text_overflow">
                                                    {/* <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_delete(item.bamboo)
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Delete
                                                    </div> */}
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_update(item.bamboo)
                                                        // update state -------------------------
                                                        set_test(decode(item.kode))
                                                        set_data_buyer({
                                                            data : JSON.parse(decode(item.data_buyer)),
                                                            response : JSON.parse(decode(item.response))
                                                        })
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Detail
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                :
                                    data &&
                                    <tr>
                                        <td colSpan="10">Belum Ada Data</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;